export default __webpack_public_path__ + "static/media/ic_discord_fill.a047d128.svg";